if (!customElements.get("banner-highlights")) {
  class ComponentBannerHighlights extends HTMLElement {
    constructor() {
      super();
      this.accordionId = this.dataset.accordionId;
      this.mode = this.dataset.mode;
      this.mainHighlightsElement = document.getElementById(this.accordionId);
      this.accordionElement = this.mainHighlightsElement
        .closest(".slide-wrapper")
        ?.querySelector("util-accordion");

      if (this.accordionElement && this.mode == "accordion") {
        this.initAccordionEvents();
        this.initHighlights();
      } else {
        this.initOutsideEvents();
        this.initFloatingHighlights();
      }
    }
    clearHighlights() {
      this.querySelectorAll(".banner-highlight").forEach((highlight) =>
        highlight.classList.remove("active")
      );
    }
    initOutsideEvents() {
      document.addEventListener("click", (event) => {
        if (
          this.querySelectorAll(".banner-highlight.active").length > 0 &&
          !(
            event.target.classList &&
            event.target.classList.contains("btn-highlight")
          )
        ) {
          this.clearHighlights();
        }
      });
    }
    initFloatingHighlights() {
      let highlightsButtons = this.querySelectorAll(".btn-highlight");
      highlightsButtons.forEach((btn) => {
        btn.addEventListener("click", (event) => {
          event.preventDefault();
          let item = event.currentTarget;
          this.clearHighlights();
          item.closest(".banner-highlight").classList.add("active");
        });
      });
    }
    initHighlights() {
      let highlightsButtons = this.querySelectorAll(".btn-highlight");
      highlightsButtons.forEach((btn) => {
        btn.addEventListener("click", (event) => {
          event.preventDefault();
          let itemId = event.currentTarget.parentNode.dataset.item;
          if (!event.currentTarget.parentNode.classList.contains("active")) {
            this.accordionElement
              .querySelector(`.accordion[data-item="${itemId}"] button`)
              .click();
          }
        });
      });
    }
    initAccordionEvents() {
      this.accordionElement.addEventListener("accordionExpand", (event) => {
        let itemId = event?.detail?.dataset.item;
        let itemElement = this.mainHighlightsElement.querySelector(
          `.item-highlight[data-item="${itemId}"]`
        );
        itemElement.classList.add("active");
      });
      this.accordionElement.addEventListener("accordionCollapse", (event) => {
        let itemId = event?.detail?.dataset.item;
        let itemElement = this.mainHighlightsElement.querySelector(
          `.item-highlight[data-item="${itemId}"]`
        );
        itemElement.classList.remove("active");
      });
    }
  }
  customElements.define("banner-highlights", ComponentBannerHighlights);
}
